import React from 'react';
import cn from 'classnames/dedupe';
import get from 'lodash/get';

const Columns = ({
  cells,
  className,
  lastColWider = false,
  includeDefaultRoleProp = true,
  lastItemClassName = 'pr-8',
}) => {
  const cellsLength = cells.length - 1;
  return cells.map((cell, index) => {
    const { className: cellClassName, ...otherCellProps } = cell.getCellProps();

    if (otherCellProps.role && !includeDefaultRoleProp) {
      delete otherCellProps.role;
    }

    const Parent = get(cell, 'parent', 'td');

    return (
      <Parent
        key={cell.id}
        {...otherCellProps}
        className={cn(
          'py-8 font-medium text-18 text-black',
          {
            'pl-8': index === 0,
            [lastItemClassName]: index === cellsLength,
            'w-1/3': lastColWider && index === cellsLength,
          },
          className,
          cellClassName,
          get(cell, 'column.className'),
        )}
      >
        {cell.render('Cell')}
      </Parent>
    );
  });
};

export default Columns;
